import { LanguageInterface } from '../../..';

export class LanguageDto implements LanguageInterface {
  id: string;
  key: string;
  nativeName: string;
  settingsLanguage: boolean;
}
